export default {"src":"/_next/static/media/page-views.b1a42ded.svg","height":75,"width":76,"blurWidth":0,"blurHeight":0};